import { put, select, takeLatest } from "redux-saga/effects";

import { getSectionPricesFail, getSectionPricesSuccess, updateProducts } from "../actions";
import {
    GET_PRODUCTS_REQUEST,
    GET_SECTION_PRICES_REQUEST,
    GetSectionPricesRequestAction,
    ProductType,
    SET_REGION,
    SetRegionAction,
} from "../types";
import api from "../../utils/api-helper/api";
import { getSectionPriceRegion } from "../../utils/constants";

function* fetchSectionPricesSaga(action: GetSectionPricesRequestAction) {
    try {
        const { region, productIds } = action.payload;
        const pricingRegion = getSectionPriceRegion(region);
        const validIds = productIds.filter(Boolean);
        if (validIds.length === 0) {
            yield put(getSectionPricesSuccess());
            return;
        }

        // @ts-ignore
        const res = yield api.post("/stripe/section-prices", { region: pricingRegion, productIds: validIds });
        const { prices, unavailable } = res.data.payload as {
            prices: {
                productId: string;
                priceId: string;
                amount: string;
                currency: string;
                formattedPrice: number;
            }[];
            unavailable: string[];
        };

        // @ts-ignore
        const products: ProductType[] = yield select((state) => state.products.products);

        const priceMap = new Map(prices.map((p) => [p.productId, p]));
        const unavailableSet = new Set(unavailable);

        const updated = products
            .map((product) => {
                const pid = product.productId;
                const isUnavailable = pid ? unavailableSet.has(pid) : false;
                const priceData = pid ? priceMap.get(pid) : undefined;
                return {
                    ...product,
                    priceId: priceData?.priceId,
                    formattedPrice: priceData ? String(priceData.amount) : undefined,
                    regionPrice: priceData ? priceData.formattedPrice / 100 : undefined,
                    currency: priceData?.currency,
                    isAvailable: !isUnavailable && !!priceData,
                };
            });

        yield put(updateProducts(updated));
        yield put(getSectionPricesSuccess());
    } catch (error) {
        yield put(getSectionPricesFail(error));
    }
}

function* onRegionChangeSaga(action: SetRegionAction) {
    localStorage.setItem("region", action.payload);
    yield put({ type: GET_PRODUCTS_REQUEST });
}

const regionSagaWatcher = [
    takeLatest(GET_SECTION_PRICES_REQUEST, fetchSectionPricesSaga),
    takeLatest(SET_REGION, onRegionChangeSaga),
];

export default regionSagaWatcher;
